/**
 * Mobile product gallery (thumbnail_slider): prev/next toggles .is-active slide.
 * SliderComponent disables arrows when only one slide has layout width; we re-enable them.
 *
 * IMPORTANT: MutationObserver must not re-enter on its own attribute writes —
 * that feedback loop kills Chrome (RESULT_CODE_KILLED_BAD_MESSAGE).
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function getSlides(viewer) {
    return Array.from(viewer.querySelectorAll('.product__media-item')).filter((el) => el.dataset.mediaId);
  }

  function getActiveIndex(list) {
    const i = list.findIndex((s) => s.classList.contains('is-active'));
    return i === -1 ? 0 : i;
  }

  function keepArrowsEnabled(viewer) {
    if (!MOBILE_MQ.matches) return;
    const list = getSlides(viewer);
    if (list.length < 2) return;
    viewer.querySelectorAll('.slider-buttons button[name="previous"], .slider-buttons button[name="next"]').forEach((btn) => {
      if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      if (btn.getAttribute('aria-disabled') === 'true') btn.removeAttribute('aria-disabled');
    });
  }

  function goTo(gallery, viewer, index) {
    const list = getSlides(viewer);
    if (list.length < 2) return;
    const i = ((index % list.length) + list.length) % list.length;
    const mediaId = list[i].dataset.mediaId;

    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    } else {
      list.forEach((slide, idx) => slide.classList.toggle('is-active', idx === i));
    }

    const current = viewer.querySelector('.slider-counter--current');
    if (current) current.textContent = String(i + 1);

    keepArrowsEnabled(viewer);
  }

  function bindArrow(gallery, viewer, button, delta) {
    if (!button || button.dataset.ssMobileBound === 'true') return;
    button.dataset.ssMobileBound = 'true';

    const onNavigate = (event) => {
      if (!MOBILE_MQ.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const list = getSlides(viewer);
      if (list.length < 2) return;
      goTo(gallery, viewer, getActiveIndex(list) + delta);
    };

    button.addEventListener('click', onNavigate, true);
  }

  function initGallery(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    keepArrowsEnabled(viewer);

    if (!viewer.dataset.ssMobileObserver) {
      viewer.dataset.ssMobileObserver = 'true';
      let quiet = false;
      const observer = new MutationObserver(function () {
        if (quiet || !MOBILE_MQ.matches) return;
        quiet = true;
        try {
          keepArrowsEnabled(viewer);
        } finally {
          quiet = false;
        }
      });
      observer.observe(viewer, {
        attributes: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });
    }

    bindArrow(gallery, viewer, viewer.querySelector('.slider-buttons button[name="previous"]'), -1);
    bindArrow(gallery, viewer, viewer.querySelector('.slider-buttons button[name="next"]'), 1);
  }

  function boot() {
    if (!MOBILE_MQ.matches) return;
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  MOBILE_MQ.addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
})();
